import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=0bc781ce"
import script from "./Time.ts?vue&type=script&lang=ts&external"
export * from "./Time.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports